<template>
  <transition name="fadeout">
    <div class="screen" v-if="show">
      <div class="complete">
        <div class="complete-img">
          <div class="img1">
            <!-- <img src="img/complete.svg" alt="completed"> -->
            <img src="img/sl_maru.jpg" alt="completed">
          </div>
          <div class="text">
            おめでとう!!<br>
            景品をもらってね!
          </div>
          <!-- <div class="img2">
            <img src="img/sl_shikaku.jpg" alt="completed2">
          </div> -->

          <div class="close-btn" @click="close">
            閉じる
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'complete-screen',
  computed: {
    show: {
      get() {
        return this.$store.state.showComplete;
      },
      set(bool) {
        this.$store.commit('updateShowComplete', bool);
      },
    },
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.screen {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 2000;
  // background-color: transparent;
  background-color: rgba(0,0,0,0.1);
}
.complete {
  position: fixed;
  top: 5vw;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 90vw;
  max-width: 800px;
  max-height: 90vh;
  background-color: rgba(255,255,255,0.8);
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.complete-img {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.img1, .img2 {
  width: 90%;
  height: 90%;
  margin: 6vh auto;
}
.text {
  color: #007C76;
  font-size: 1rem;
  margin-bottom: 6vh;
}
.ctr-box {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 2001;
}
.close-btn {
  width: 80%;
  margin: 0 auto;
  padding: 0.8rem 0;
  font-size: 1rem;
  color: #999;
  border-top: 1px solid #eee;
}

.fadeout-enter-active {
  transition: all .8s ease;
}
.fadeout-leave-active {
  transition: all .6s ease;
}
.fadeout-enter, .fadeout-leave-to {
  opacity: 0;
}

@media screen and (min-width:480px) {
  .img1, .img2 {
    width: 80%;
    height: 80%;
  }
  .text {
    font-size: 1.6rem;
  }
  .close-btn {
    padding: 1rem 0;
    font-size: 1.6rem;
  }
}
</style>
